import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgVotingIcon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.33073 0.666748H15.6641V7.6392L17.3307 7.09866V16.5001H0.664062V7.09866L2.33073 7.6392V0.666748ZM3.58073 8.04461L8.9974 9.80137L14.4141 8.04461V1.91675H3.58073V8.04461ZM6.4974 4.83341H11.4974V6.08341H6.4974V4.83341ZM1.91406 8.81817V15.2501H16.0807V8.81817L8.9974 11.1155L1.91406 8.81817Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgVotingIcon);
export default ForwardRef;
